import IncidentTab from '@/components/request/elements/IncidentTab/IncidentTab.vue';
import IncidentConfirmTab from '@/components/request/elements/IncidentConfirmTab/IncidentConfirmTab.vue';
import DeletedIncidentTab from '@/components/request/elements/DeletedIncidentTab/DeletedIncidentTab.vue';
import { mapActions } from 'vuex';
import { $EventBus } from '@/main';

export default {
	name: 'RequestList',
	data() {
		return {
			tab: 0,
			loadingExport: false,
			loadingSummaryExport: false,
			exportDateRangeDialog: false,
			menuStartDate: false,
			menuEndDate: false,
			exportFilters: {
				startDate: null,
				endDate: null,
			},
			breadcrumbs: [
				{
					text: 'Inicio',
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: 'Dashboard',
					},
				},
				{
					text: 'Incidentes',
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: 'IncidentsHome',
					},
				},
				{
					text: 'Atención de Tickets',
					link: true,
					exact: true,
					disabled: true,
				},
			],
		};
	},

	watch: {
		tab(newTab) {
			this.$nextTick(() => {
				if (newTab === 0 && this.$refs.incidentTab) {
					this.$refs.incidentTab.getTickets();
				} else if (newTab === 1 && this.$refs.deletedIncidentTab) {
					this.$refs.deletedIncidentTab.getTickets();
				}
			});
		},
	},

	created() { },

	methods: {
		...mapActions('ticket', ['exportTicketsReport', 'exportSummaryTicketsReport']),

		getIncidentTabExportFilters() {
			const baseFilters = this.$refs.incidentTab?.ticketfilters || {};
			const filters = { ...baseFilters };

			if (filters.status?.includes('ALL')) {
				filters.status = null;
			} else if (Array.isArray(filters.status)) {
				filters.status = filters.status.join(',');
			}

			delete filters.page;
			delete filters.limit;
			delete filters.pagination;

			return filters;
		},

		async exportTickets() {
			this.openExportDateRangeDialog();
		},

		openExportDateRangeDialog() {
			this.exportFilters = {
				startDate: null,
				endDate: null,
			};
			this.exportDateRangeDialog = true;
		},

		async executeExportTickets() {
			this.loadingExport = true;
			try {
				const filters = this.getIncidentTabExportFilters();
				
				// Agregar filtros de fecha si están definidos
				if (this.exportFilters.startDate) {
					filters.from_date = this.exportFilters.startDate;
				}
				if (this.exportFilters.endDate) {
					filters.to_date = this.exportFilters.endDate;
				}

				const { ok, error } = await this.exportTicketsReport(filters);
				if (ok) {
					$EventBus?.$emit('showSnack', 'success', 'Reporte exportado exitosamente');
					this.exportDateRangeDialog = false;
				} else {
					$EventBus?.$emit('showSnack', 'error', error || 'Error al exportar el reporte');
				}
			} catch (e) {
				$EventBus?.$emit('showSnack', 'error', 'Error inesperado al exportar el reporte');
			} finally {
				this.loadingExport = false;
			}
		},

		async exportSummaryTickets() {
			this.loadingSummaryExport = true;
			try {
				const { ok, error } = await this.exportSummaryTicketsReport();
				if (ok) {
					$EventBus?.$emit('showSnack', 'success', 'Reporte de resumen de tickets de atención exportado exitosamente');
				} else {
					$EventBus?.$emit('showSnack', 'error', error || 'Error al exportar el reporte resumen de tickets de atención');
				}
			} catch (e) {
				$EventBus?.$emit('showSnack', 'error', 'Error inesperado al exportar el reporte resumen de tickets de atención');
			} finally {
				this.loadingSummaryExport = false;
			}
		},

		//[TODO] mover a un archivo para reutilizar
		isAllowed(module, page, activityName) {

			const activities = this.$store.state.auth.activities || [];
			const found = activities.some(
				(activity) =>
					activity.module_name === module &&
					activity.page_name === page &&
					activity.activity_name === activityName
			);

			return found;
		},
	},

	beforeDestroy() { },
	destroyed() {
	},

	components: {
		IncidentTab,
		IncidentConfirmTab,
		DeletedIncidentTab,
	},

	computed: {
		hasReturnListPermission() {
			return this.$store.getters['auth/hasActivity'](
				'devoluciones',
				'listaDevoluciones',
				'listarDevoluciones'
			);
		},
	},
};
